export default __webpack_public_path__ + "static/imageSP-cb53dc3a4bd476e41cdd35a76559ddad.svg";